<script lang="ts">
  import { Users } from "lucide-svelte";
  interface Props {
    todayUv: number;
    t: (path: string) => string;
  }
  let { todayUv, t }: Props = $props();
</script>

<div class="rounded-xl border bg-card p-4 shadow-sm flex flex-col justify-between">
  <div class="flex items-center justify-between">
    <p class="text-xs font-medium text-muted-foreground uppercase tracking-wider">{t('dashboard.kpi.today_uv')}</p>
    <Users class="h-4 w-4 text-primary" />
  </div>
  <div class="mt-2">
    <span class="text-3xl font-extrabold tracking-tight">{todayUv}</span>
    <span class="text-xs text-muted-foreground ml-1">{t('dashboard.kpi.uv_unit')}</span>
  </div>
  <div class="mt-3 flex items-center justify-between text-xs text-muted-foreground border-t pt-2">
    <span>{t('dashboard.kpi.realtime_stat')}</span>
    <span class="text-emerald-600 font-medium">{t('dashboard.kpi.realtime')}</span>
  </div>
</div>